import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from "../authentication/authentication.service";
import { LoggingService } from "../logging/logging.service";
import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { CreateBusinessCategory, BusinessCategory, EditBusinessCategory } from "../../models/inModels/business-category";
import { BusinessProfile, CreateBusinessProfile } from "../../models/inModels/BusinessProfile";
import { AutoCompleteEvent } from '../../models/Utility/autoCompleteEvent';
import { CategoryGroup, CreateCategoryGroup, EditCategoryGroup } from '../../models/inModels/CategoryGroup';
import { environment } from '../../../environments/environment.prod';

@Injectable()
export class BusinessService {
	private routeCategory = '/api/business/category';
	private routeProfile = '/api/business/profile';
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }

	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getBusinessProfile(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeProfile}/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	create(user: CreateBusinessCategory): Promise<BusinessCategory> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/create`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as BusinessCategory)
			.catch(error => this.logging.handleError(error));
	}

	update(user: EditBusinessCategory): Promise<BusinessCategory> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as BusinessCategory)
			.catch(error => this.logging.handleError(error));
	}
	delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
	get(id: number): Promise<BusinessCategory> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as BusinessCategory)
			.catch(error => this.logging.handleError(error));
	}

	getDropdownList(): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/dropdown`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getDropdown(event): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/dropdown`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}


	getUsersProfile(id: string): Promise<BusinessProfile> {
		return this.http.get(`${this.auth.apiUrl}${this.routeProfile}/get/user/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as BusinessProfile)
			.catch(error => this.logging.handleError(error));
	}

	createProfile(user: CreateBusinessProfile): Promise<BusinessProfile> {
		return this.http.post(`${this.auth.apiUrl}${this.routeProfile}/create`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as BusinessCategory)
			.catch(error => this.logging.handleError(error));
	}

	getDropdownClientsList(): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/dropdown/clients`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getDropdownClients(event): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/dropdown/clients`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getOrAddClient(name: string): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/getoradd/client?name=${name}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getDropdownGroupsList(): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/groups/list`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
	getGroupsList(event: AutoCompleteEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/groups/list`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	searchGroup(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/groups/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	updateGroup(user: EditCategoryGroup): Promise<CategoryGroup> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/group/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as CategoryGroup)
			.catch(error => this.logging.handleError(error));
	}

	createGroup(user: CreateCategoryGroup): Promise<CategoryGroup> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/group/create`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as CategoryGroup)
			.catch(error => this.logging.handleError(error));
	}

	deleteGroup(id: number): Promise<CategoryGroup> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/group/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as CategoryGroup)
			.catch(error => this.logging.handleError(error));
	}

	getGroup(id: number): Promise<CategoryGroup> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/group/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as CategoryGroup)
			.catch(error => this.logging.handleError(error));
	}
	getListOfCoaches(): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}/api/learning-uploads/coaches`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	updateProgrammeStatus(data: any): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}/api/learning-statistics/programme-status`, data, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
	getProgrammeStatus(userId: string): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}/api/learning-statistics/programme-status/${userId}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
	getPastProgrammeMembers(programmeId: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}/api/learning-statistics/past-members/${programmeId}`,
			{ headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/business/business-category.service.ts